import React from 'react';
import Form from '../form/form';

const NewsletterForm = () => <Form namespace="newsletter" />;

export default NewsletterForm;
